import SectionBypass from '@/components/SectionBypass';

export default {
  path: '/statistics',
  component: SectionBypass,
  children: [
    {
      path: '',
      component: () => import(
        /* webpackChunkName: "dashboard" */
        /* webpackPrefetch: true */
        './index'
      ),
    },
    {
      path: 'project/:id',
      component: () => import(
        /* webpackChunkName: "project-stats" */
        /* webpackPrefetch: true */
        './Project'
      ),
    },
    {
      path: 'worker/:id',
      name: 'workerStatistic',
      component: () => import(
        /* webpackChunkName: "project-stats" */
        /* webpackPrefetch: true */
        './Worker'
      ),
    },
  ],
};
